import { useCallback } from 'react';
import { InlineMediaPlayer } from 'recording-review-components-lib/media-player/variant-inline/InlineMediaPlayer';
import { composeMediaElement } from 'recording-review-components-lib/media-player/hoc/composeMediaElement';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import { MediaActions } from './MediaActions';
import { jsx as _jsx } from "react/jsx-runtime";
const HTMLMediaElement = composeMediaElement(['INTERNAL_RECORDING_URL_PARSER']);
export const MediaPlayer = props => {
  const handlePlay = useCallback(() => {
    CommunicatorLogger.log('communicator_timelineInteraction', {
      action: 'Listen to call recording',
      activity: 'call',
      channel: 'outbound call'
    });
  }, []);
  return /*#__PURE__*/_jsx(InlineMediaPlayer, {
    HTMLMediaElement: HTMLMediaElement,
    actionWell: /*#__PURE__*/_jsx(MediaActions, Object.assign({}, props)),
    onPlayCallback: handlePlay
  });
};